import ArticleView from "../utils/ArticleView";

const ArticleAdvices = () => {
  return ArticleView("advices");
};
  
export default ArticleAdvices;